import React from 'react'
import { PaycodeDistributionTable } from 'components/table/paycodeDistribution/PaycodeDistributionTable'

const PaycodeDistribution = () => {
    return (
        <>
            <PaycodeDistributionTable />
        </>
    )
}

export { PaycodeDistribution }